/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

function energyScoreDirective() {
    return {
        restrict: 'E',
        scope: {
            productEfficiency: '=',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: energyScoreController,
        template: require('./energyScoreView.html')
    };
}

energyScoreController.$inject = [
    '$scope',
    'CmsContentService',
    '$filter',
];
function energyScoreController (
    $scope,
    CmsContentService,
    $filter
) {

    this.$onInit = function () {
        var vm = this;

        // Specifying whether to use 'a' or 'an' before the category names.
        vm.categoryName = vm.productEfficiency.category.name.toLowerCase();
        vm.categoryId = vm.productEfficiency.category.id;

        var lessOrMore = "details_page:energy_efficiency_sentence_more";
        if (vm.productEfficiency.is_efficient) {
            lessOrMore = "details_page:energy_efficiency_sentence_less";
        }

        var modelName = vm.productEfficiency.brand + " " + vm.productEfficiency.model_number;

        var renderCMSContent = function () {
            CmsContentService.getMarketPlaceText(
                'details_page:energy_efficiency_sentence_efficiency',
                {
                    'less_or_more':
                        [
                            '<span>{less_or_more}</span>',
                            {
                                'less_or_more': lessOrMore
                            }
                        ],
                    'efficiency_description': vm.productEfficiency.efficiency_description,
                    'category_name': $filter('lowercase')(vm.productEfficiency.category.name),
                    'model': modelName
                },
                vm.productEfficiency.category.id
            ).then(function(text) {
                vm.energyEfficiencySentence1 = text;
            });

            CmsContentService.getMarketPlaceText(
                'details_page:energy_efficiency_sentence_score',
                {
                    'category_name': $filter('lowercase')(vm.categoryName)
                },
                vm.productEfficiency.category.id
            ).then(function(text) {
                vm.energyEfficiencySentence2 = text;
            });
        };

        $scope.$watch('vm.productEfficiency.efficiency_description', renderCMSContent);
    }
}

module.exports = energyScoreDirective;
